import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';

import firebase from "../firebase/FirebaseProvider";
import { withRouter } from 'react-router';
import './signup.css';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loginFailed : false
    };

    this.handleLogin = this.handleLogin.bind(this);
    this.handleEmailUpdate = this.handleEmailUpdate.bind(this);
    this.handlePasswordUpdate = this.handlePasswordUpdate.bind(this);
    this.handleSendPasswordResetEmail = this.handleSendPasswordResetEmail.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleEmailUpdate(event) {
    this.setState({ email: event.target.value });
  }

  handlePasswordUpdate(event) {
    this.setState({ password: event.target.value });
  }

  handleLogin(e) {
    e.preventDefault();
    const self = this;
    this.verifyEmailPassword();
    const { email, password } = this.state;
    ReactGA.event({
      category: 'Login',
      action: 'Email Login Button Click'
    });
    firebase.auth().signInWithEmailAndPassword(email, password)
      .then(user => {
        if(self.props.match.path == '/login') {
          self.props.history.push("/settings?signup-redirect=true");
        }
      })
      .catch(err => {
        this.setState({ loginFailed: true });
        const errorMsg = JSON.stringify(err);
        ReactGA.event({
          category: 'Login',
          action: 'Email Login Error',
          label: errorMsg
        });
      });
  }

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.handleLogin(e);
    }
  }

  verifyEmailPassword() {
    //TODO Add other verification
    if (this.state.email === "" || this.state.password === "") {
      alert("Email and Password are required");
      return;
    }
  }

  handleSendPasswordResetEmail(e) {
    e.preventDefault();
    let forgotPasswordEmail = this.state.email;
    firebase.auth().sendPasswordResetEmail(forgotPasswordEmail).then(function () {
      alert(`Forgot password Email sent to: ${forgotPasswordEmail}`);
    }).catch(function (error) {
      alert('Error while sending password reset email:' + error);
    });
  }

  render() {
    ReactGA.pageview('/login');
    return (
      <div className="login-form">
        <h1>Login</h1>
        <form id='credential-form'>
          <input type="text" placeholder="Email" value={this.state.email} onChange={this.handleEmailUpdate} />
          <input type="password" placeholder="Password" value={this.state.password} onChange={this.handlePasswordUpdate} onKeyDown={this.handleKeyDown} />
        </form>

        <div className='action-buttons'>
          <form onSubmit={this.handleLogin} id='login-form'>
            <input type="submit" value="Login" />
          </form>
        </div>
        {(this.state.loginFailed) && <div>Either Email or password is invalid. Please try again</div>}
        <Link className='sign-up-link' to='/sign-up'>
          <span>Create New Account</span>
        </Link>

        <Link className='forgot-password-link' to='/forgot-password'>
          <span>Forgot Password</span>
        </Link>
      </div>
    )
  }
}

export default withRouter(Login);
